import { useState, useEffect, Fragment, useRef } from "react";
import FileInput from "react-fine-uploader/file-input";
import { Spinner } from "react-bootstrap";
import FineUploaderS3 from "fine-uploader-wrappers/s3";
import "react-fine-uploader/gallery/gallery.css";
import Utils from "../../../../utils/index.js";
import { t } from "i18next";
import { toast } from "react-toastify";
import axios from "axios";
import _ from "lodash";
import OneDriveLogin from "../../../../pages/OneDrive/index.js";
import "./upload.scss";

const FileUploadComponent = ({
  id,
  referenceId,
  setProgressVisible,
  multipleFiles = [],
  description,
  title = () => {},
  setUploadProgress,
  setFilelist,
  fetchFiles,
  instanceId,
  fileProcessing,
  progress,
  setProgress,
  handleFormBlur,
  fromWorkflow = false,
  assistantData,
  workflowUuid,
  isEditable,
  generateInstanceData,
  uuid,
  uploadstatus,
  setUploadStatus,
  defaultValue,
  hidden,
}) => {
  const token = Utils.getLocalStorageItem("_t");
  const [config, setConfig] = useState(null);
  const [filesData, setFilesData] = useState("");
  const fileExtensions = config?.allowedTypes
    ? Utils.getAllowExtensions(config.allowedTypes)
        .map((ext) => `.${ext}`)
        .join(",")
    : "";

  const [showDropdown, setShowDropdown] = useState(true);
  const [showOneDrive, setShowOneDrive] = useState(false);
  const [foldername, setFolderName] = useState([]);
  const [subsciptionId, setSubscriptionId] = useState("");
  const [showSharePoint, setShowSharePoint] = useState(false);
  const [loading, setLoading] = useState(false);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedUnsubscribeInfo, setSelectedUnsubscribeInfo] = useState(null);
  const uuidData = params.get("uuid");
  const currentUser = JSON.parse(Utils.getLocalStorageItem("currentUser"));
  const handleOptionSelect = (option) => {
    if (option === "system") {
      document.getElementById("fileUploader")?.click();
    } else if (option === "onedrive") {
      localStorage.setItem("source", "oneDrive");
      setShowOneDrive(true);
    } else if (option === "sharepoint") {
      setShowOneDrive(true);
      localStorage.setItem("source", "sharepoint");
    }
  };

  const latestFile = _.sortBy(multipleFiles, "createdAt").reverse();
  useEffect(() => {
    if (localStorage.getItem("login")) {
      const source = localStorage.getItem("source");
      setShowOneDrive(true);
      if (source === "sharepoint") {
      }
      localStorage.removeItem("login");
    }
  }, []);
  const fetchFolderUnhook = async (subsciptionId, emailId, integration) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_INFINIIT_BASE_URL}/teams-channel-api/unregisterOneDriveChangeWebhook/${subsciptionId}`,
        {
          emailId: emailId,
          orgId: currentUser?.orgId,
          channelId: instanceId,
          assistantId: uuid,
          type: "context",
          integration: integration,
        }
      );
      if (!_.isEmpty(response)) {
        toast.success("Folder successfully unregistered!");
        fetchFolderName();
      }
    } catch (error) {
      console.error("Error fetching root items:", error);
    }
  };
  const handleUnsubscribeClick = (subscriptionId, emailId, integration) => {
    setSelectedUnsubscribeInfo({ subscriptionId, emailId, integration });
    setShowConfirmModal(true);
  };

  let size = 0;
  let instanceData;
  const fetchConfig = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}filehandler/config`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Access-Token": token,
          },
        }
      );

      if (!response.ok) {
        console.error("Failed to fetch configuration!");
        return;
      }

      const configData = await response.json();
      setConfig(configData?.data);
    } catch (error) {
      console.error("Error fetching configuration:", error);
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);
  useEffect(() => {
    if (instanceId && uuid) {
      fetchFolderName();
    }
  }, [instanceId, uuid]);

  const totalFilesCount = useRef(0);
  const completedFilesCount = useRef(0);
  const fileSizesByFileName = useRef({});

  const uploader = new FineUploaderS3({
    options: {
      debug: true,
      multiple: true,
      retry: { enableAuto: true, autoAttemptDelay: 5, maxAutoAttempts: 50 },
      chunking: {
        enabled: true,
        partSize: 5 * 1024 * 1024,
        concurrent: { enabled: true },
      },
      resume: { enabled: true, recordsExpireIn: 1 },
      objectProperties: {
        region: config?.confg?.region,
        key: function (fileId) {
          const FileName = this.getName(fileId);
          const FileWithUUId =
            config?.confg?.S3StoragePath +
            "/" +
            this.getUuid(fileId) +
            "." +
            FileName?.substr(FileName?.lastIndexOf(".") + 1);
          return FileWithUUId;
        },
      },
      request: {
        endpoint: `https://${config?.confg?.hostName}`,
        accessKey: config?.confg?.accessKeyId,
      },
      signature: {
        endpoint: `${process.env.REACT_APP_BASE_URL}filehandler/signature`,
        version: 4,
        customHeaders: {
          Accept: "application/json",
          "X-Access-Token": token,
        },
      },
      uploadSuccess: {},
      deleteFile: {
        enabled: true,
        endpoint: config?.confg?.hostName || "",
      },
      validation: {
        allowedExtensions: Utils.getAllowExtensions(config?.allowedTypes),
        sizeLimit: Utils.getAllowFileSize(config?.maxSizeEachFileInMB),
        itemLimit: Utils.getAllowFileLimitMulti(
          config?.maxFiles,
          multipleFiles.length
        ),
      },
      callbacks: {
        onValidateBatch: (fileOrBlobDataArray) => {
          let isValid = true;
          let existingFiles = new Set(
            [...multipleFiles].map((file) => file.fileName)
          );

          for (let file of fileOrBlobDataArray) {
            const FILE_NAME = file.name;

            if (existingFiles.has(FILE_NAME)) {
              toast.error(
                "One or more selected files have already been uploaded. Please remove duplicate files and try again."
              );
              setProgressVisible(false);
              setUploadStatus(false);
              isValid = false;
              break;
            }
          }

          if (!isValid) {
            return false;
          }

          return true;
        },
        onValidate: (fileOrBlobData) => {
          setUploadStatus(true);

          //   filesLengthMulti++;
          totalFilesCount.current++;
          const FILE_NAME = fileOrBlobData.name;
          //   if (filesLength > config.maxFiles) {
          //     toast.error("More than " + config.maxFiles + " files not allowed");
          //     return false;
          //   }
          let extension = fileOrBlobData?.name?.split(".")?.[1];
          // if (extension && Utils.getAllowExtensions(config?.allowedTypes).indexOf(extension) == -1) {
          //   const message = `${extension?.[0]?.toUpperCase() + extension?.slice(1, extension.length)} ${t('filesAreNotAllowed')}`;
          //   toast.error(message);
          //   return false;
          // }
          const FILE_EXTENSION = FILE_NAME.split(".").pop().toLowerCase();
          const ALLOWED_EXTENSIONS = Utils.getAllowExtensions(
            config?.allowedTypes
          );
          if (!ALLOWED_EXTENSIONS.includes(FILE_EXTENSION)) {
            toast.error(`File type .${FILE_EXTENSION} is not allowed.`);
            setUploadStatus(false);
            return false;
          }
          if (
            fileOrBlobData?.size >
            Utils.getAllowFileSize(config?.maxSizeEachFileInMB)
          ) {
            toast.error(
              `${FILE_NAME} is too large, Max file size limit is ${config?.maxSizeEachFileInMB} MB`
            );
            setUploadStatus(false);
            return false;
          }
          if (
            fileOrBlobData?.name &&
            fileOrBlobData?.size &&
            fileOrBlobData?.size
          ) {
            setProgressVisible(true);
            size = fileOrBlobData.size;
            fileSizesByFileName.current[FILE_NAME] = fileOrBlobData.size;
            setFilelist((prev) => [
              ...prev,
              {
                fileName: fileOrBlobData?.name,
                size: fileOrBlobData?.size,
                status: "pending",
                type: FILE_NAME?.split(".")?.[FILE_NAME?.split(".").length - 1],
                isProcessed: false,
                step: 0,
                message: "File upload successful. Processing initiated...",
              },
            ]);
          }
          return true;
        },
        onComplete: async (id, name, response) => {
          setTimeout(() => {
            setUploadProgress(0);
            setProgressVisible(false);
          }, 2000);
          completedFilesCount.current++;
          if (response && response.success) {
            const fileKey = uploader.methods.getKey(id);
            if (fileKey) {
              let filesData = fileKey.split("/");
              filesData = filesData[filesData.length - 1];
              setFilesData(filesData);
              let assistantId = referenceId;
              if (!referenceId) {
                const response = await axios.post(
                  `${process.env.REACT_APP_BASE_URL}genai/generate_assistant_id`,
                  {},
                  {
                    headers: {
                      "X-Access-Token": token,
                      Accept: "application/json",
                    },
                  }
                );
                assistantId = response.data.assistantId;
              }
              if (fromWorkflow && !instanceId) {
                try {
                  const response = await generateInstanceData(assistantId);
                  instanceData = response.data;
                  instanceId = response.data.instanceUuid;
                } catch (error) {
                  console.log(error, "error");
                }
              }

              const fileSize =
                uploader.methods.getSize?.(id) ??
                fileSizesByFileName.current[name];
              uploadFilesMulti(filesData, name, assistantId, fileSize);
            }
          }
          setUploadStatus(false);
        },
        onError: (id, name, response, xhrOrXdr) => {
          setProgressVisible(false);
          setUploadStatus(false);
          if (response) {
            let errorMsg = "Something went wrong.";
            if (response.indexOf("size") > -1) {
              errorMsg = `${name} is too large, Max file size limit is ${config?.maxSizeEachFileInMB} MB`;
            }

            if (response.indexOf("extension") > -1) {
              errorMsg = `Valid extensions for uploading files are :${Utils.getAllowExtensions(
                config?.allowedTypes
              ).map((ele) => " " + ele)}.`;
            }

            if (response.indexOf("limit") > -1) {
              errorMsg = `You have left only ${Utils.getAllowFileLimit(
                0,
                multipleFiles.length
              )} files for now to upload`;
            }
          }
        },
        onProgress: (id, name, uploadedBytes, totalBytes) => {
          setProgress(true);

          setTimeout(() => {
            if (navigator?.onLine) {
              var percent = (uploadedBytes / totalBytes) * 100;
              setUploadProgress(percent);
            }
          }, 1000);
        },
        onCancel: (id, name) => {
          setUploadStatus(false);
        },
      },
    },
  });
  const fetchFolderName = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_INFINIIT_BASE_URL}/teams-channel-api/onedrivefolders`,
        {
          emailId: currentUser?.emailID,
          orgId: currentUser?.orgId,
          channelId: instanceId,
          assistantId: uuid,
          type: "context",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!_.isEmpty(response)) {
        setFolderName(response?.data);
        setSubscriptionId(response?.data?.data[0]?.subscriptionId);
      }
    } catch (error) {
      console.error("Error fetching root items:", error);
    }
  };

  const uploadFilesMulti = async (filesData, name, reference = null, fileSize = null) => {
    try {
      setUploadStatus(true);
      const sizeToSend = fileSize ?? size;

      const addFileInfoResponse = await fetch(
        `${process.env.REACT_APP_API}filehandler/addfileinfo`,
        {
          method: "POST",
          body: JSON.stringify({
            referenceId: reference || referenceId,
            referenceType: "Instance",
            fileName: name,
            key: filesData,
            instanceUuid: instanceId,
            ...(sizeToSend && { fileSize: sizeToSend }),
          }),
          headers: {
            "Content-Type": "application/json",
            "X-access-token": token,
          },
        }
      );
      const responseData = await addFileInfoResponse.json();
      if (!addFileInfoResponse.ok) {
        toast.error("Failed to add file info to MongoDB!");
      } else {
        if (
          completedFilesCount.current === totalFilesCount.current &&
          totalFilesCount.current !== 0
        ) {
          if (totalFilesCount.current > 1) {
            toast.success("Files added successfully!");
          } else {
            toast.success("File added successfully!");
          }
          completedFilesCount.current = 0;
          totalFilesCount.current = 0;
        }
      }
      setUploadProgress(100);
      setProgress(false);
      setFilelist((prev) => {
        const newFileList = prev.map((data) => {
          if (
            data?.status == "pending" &&
            responseData?.data?.fileName === data.fileName
          ) {
            data = {
              ...responseData?.data,
              size: data?.size,
              type: data?.type,
              step: data?.step,
              message: data?.message,
            };
            data.status = "pending";
          }

          return data;
        });
        if (fromWorkflow && typeof handleFormBlur === "function") {
          const fileTypeInput = {
            target: {
              name: id, // Replace with the actual input _id
              value: newFileList.map((file) => ({ fileId: file._id })), // Pass the response as a file list
              instanceData,
            },
          };

          handleFormBlur(fileTypeInput);
        }
        return newFileList;
      });
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setUploadStatus(false);
    }
  };
  return (
    <>
      {isEditable ? (
        <Fragment>
          <div className="heading-box">
            <h4 className="instruct-title">{title}</h4>
          </div>
          <p className="mb-2 ulodt">{description}</p>
          <div className="upload-file-box">
            <div className="input-wrap-row-wrap">
              <div className="from-input-wrapper">
                <div
                  className="file-uploader"
                  // onClick={() => setShowDropdown(!showDropdown)}
                  style={{
                    cursor:
                      latestFile[0]?.status === "pending"
                        ? "not-allowed"
                        : "default",
                  }}
                >
                  <FileInput
                    uploader={uploader}
                    multiple
                    disabled={
                      latestFile[0]?.status === "pending" || !isEditable
                    }
                    id="fileUploader"
                    accept={fileExtensions}
                    title=""
                    style={{ display: "none" }}
                  />
                  <div className="fil-uplaod-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M7.16699 13.3333L10.5003 10M10.5003 10L13.8337 13.3333M10.5003 10V17.5M17.167 13.9524C18.1849 13.1117 18.8337 11.8399 18.8337 10.4167C18.8337 7.88536 16.7816 5.83333 14.2503 5.83333C14.0682 5.83333 13.8979 5.73833 13.8054 5.58145C12.7187 3.73736 10.7124 2.5 8.41699 2.5C4.96521 2.5 2.16699 5.29822 2.16699 8.75C2.16699 10.4718 2.8632 12.0309 3.98945 13.1613"
                        stroke="#475467"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  {/* <div className="linktext-upload">
                    <strong>{t("clickToUpload")}</strong>
                  </div> */}
                  {showDropdown && (
                    <div className="upload-dropdown d-flex  flex-column flex-sm-row gap-2 justify-content-center align-items-center mt-2 text-nowrap">
                      <button
                        onClick={(e) => {
                          handleOptionSelect("system");
                          e.preventDefault();
                        }}
                        disabled={loading}
                        className="upload-btncolored"
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11 7V15M7 11H15M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>
                        </svg>
                        Local Computer
                      </button>

                      <button
                        onClick={(e) => {
                          handleOptionSelect("onedrive");
                          e.preventDefault();
                        }}
                        disabled={loading}
                        className="upload-btncolored"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="22"
                          height="22"
                          fill="rgba(255,255,255,1)"
                        >
                          <path d="M9.98392 5.05991C11.1323 3.22236 13.1734 2 15.5 2C19.0899 2 22 4.91015 22 8.5C22 9.58031 21.7365 10.5991 21.2701 11.4955C22.3351 12.4985 23 13.9216 23 15.5C23 18.5376 20.5376 21 17.5 21H9C4.58172 21 1 17.4183 1 13C1 8.58172 4.58172 5 9 5C9.33312 5 9.66149 5.02036 9.98392 5.05991ZM12.0554 5.60419C14.0675 6.43637 15.6662 8.06578 16.4576 10.0986C16.7951 10.0339 17.1436 10 17.5 10C18.2351 10 18.9366 10.1442 19.5776 10.4059C19.8486 9.82719 20 9.18128 20 8.5C20 6.01472 17.9853 4 15.5 4C14.1177 4 12.8809 4.6233 12.0554 5.60419ZM17.5 19C19.433 19 21 17.433 21 15.5C21 13.567 19.433 12 17.5 12C16.5205 12 15.6351 12.4023 14.9998 13.0507C14.9999 13.0338 15 13.0169 15 13C15 9.68629 12.3137 7 9 7C5.68629 7 3 9.68629 3 13C3 16.3137 5.68629 19 9 19H17.5Z"></path>
                        </svg>
                        OneDrive
                      </button>

                      <button
                        onClick={(e) => {
                          handleOptionSelect("sharepoint");
                          e.preventDefault();
                        }}
                        disabled={loading}
                        className="upload-btncolored"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 64 64"
                          width="22"
                          height="22"
                        >
                          <rect width="64" height="64" fill="#fff" rx="8" />
                          <circle cx="26" cy="32" r="12" fill="#0078d4" />
                          <circle cx="38" cy="26" r="12" fill="#00a6ed" />
                          <circle cx="38" cy="38" r="12" fill="#2d7d9a" />
                        </svg>
                        Sharepoint
                      </button>
                    </div>
                  )}
                </div>
                {loading && (
                  <div className="d-flex align-items-center justify-content-center mt-2">
                    <Spinner
                      animation="border"
                      style={{ width: "25px", height: "25px" }}
                    />
                  </div>
                )}

                {showOneDrive && (
                  <OneDriveLogin
                    uuid={uuid}
                    instanceId={instanceId}
                    setShowOneDrive={setShowOneDrive}
                    setFolderName={setFolderName}
                    fetchFolderName={fetchFolderName}
                    type="context"
                    source={localStorage.getItem("source") || "oneDrive"}
                    setShowSharePoint={setShowSharePoint}
                    setLoading={setLoading}
                  />
                )}
                {foldername?.data?.length > 0 && (
                  <div className="file-upload-modale mt-3">
                    <div className="file-list">
                      <ul>
                        {foldername.data.map((folder, index) => (
                          <li
                            className="file-item selected"
                            style={{ cursor: "default" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="rgba(0,97,175,1)"
                            >
                              <path d="M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5ZM20 11H4V19H20V11ZM20 9V7H11.5858L9.58579 5H4V9H20Z"></path>
                            </svg>
                            <div className="oneDrive">
                              {" "}
                              <span key={index}>
                                {folder.folderName}
                                {index !== foldername.data.length - 1
                                  ? ""
                                  : ""}{" "}
                                {folder?.integration && (
                                  <div className="file-info">
                                    source:{" "}
                                    {(folder?.integration == "oneDrive" &&
                                      "OneDrive") ||
                                      (folder?.integration == "sharepoint" &&
                                        "Sharepoint")}
                                  </div>
                                )}
                              </span>
                              <span
                                className="ms-4"
                                onClick={() =>
                                  handleUnsubscribeClick(
                                    folder?.subscriptionId,
                                    folder?.emailId,
                                    folder?.integration
                                  )
                                }
                                style={{
                                  backgroundColor: "#ff4d4f",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "8px",
                                  padding: "6px 14px",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  boxShadow: "0 2px 6px rgba(255, 77, 79, 0.3)",
                                  cursor: "pointer",
                                  transition: "all 0.3s ease-in-out",
                                }}
                                onMouseOver={(e) => {
                                  e.target.style.backgroundColor = "#d9363e";
                                  e.target.style.boxShadow =
                                    "0 4px 10px rgba(217, 54, 62, 0.4)";
                                }}
                                onMouseOut={(e) => {
                                  e.target.style.backgroundColor = "#ff4d4f";
                                  e.target.style.boxShadow =
                                    "0 2px 6px rgba(255, 77, 79, 0.3)";
                                }}
                              >
                                Unsubscribe
                              </span>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
                {showConfirmModal && (
                  <div className="modal-backdrop">
                    <div className="confirm-modal">
                      <p>Are you sure you want to unsubscribe this folder?</p>
                      <div className="actions">
                        <button
                          className="confirm-btn"
                          onClick={async (e) => {
                            e.preventDefault();
                            await fetchFolderUnhook(
                              selectedUnsubscribeInfo.subscriptionId,
                              selectedUnsubscribeInfo.emailId,
                              selectedUnsubscribeInfo?.integration
                            );
                            setShowConfirmModal(false);
                            setSelectedUnsubscribeInfo(null);
                          }}
                        >
                          Yes
                        </button>
                        <button
                          className="cancel-btn"
                          onClick={() => {
                            setShowConfirmModal(false);
                            setSelectedUnsubscribeInfo(null);
                          }}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Fragment>
      ) : (
        <div className="heading-box">
          <h4 className="instruct-title">Files</h4>
        </div>
      )}
    </>
  );
};

export default FileUploadComponent;
